import React, { useEffect, useState } from 'react'
import { Badge, Modal } from 'react-bootstrap'

const ReportModal = (props) => {
  const [myArray, setArray] = useState();
useEffect(()=>{
const seperate =()=>{
  let myString = props.report;
  setArray( myString.split(","))
}
seperate();
},[props.report])
  return (
    <div>
       <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" >
          <h6 style={{color:"red", paddingRight:"5px"}}>Listing Reported      
          <Badge pill bg="outline-danger" style={{color:"red", backgroundColor:"#ffcccb",marginLeft:"40px", paddingLeft:"30px", paddingRight:"30px",fontSize:"15px"}}>
          Reports
      </Badge></h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <div style={{margin:"5px", padding:"10px", backgroundColor:"#ffcccb", borderRadius:"5px"}}>
        <h4 style={{color:"red"}}>• {myArray ? myArray[0] :""}</h4>
        <p>
        {myArray ? myArray[1] :""}     
        </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button style={{color:"black", padding:"5px", backgroundColor:"#D3D3D3", borderRadius:"5px", border:"none",paddingInline:"40px" }} onClick={props.onHide}>Cancel</button>
      </Modal.Footer>
    </Modal>
    </div>
  )
}

export default ReportModal
